<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang"></Header>
		<div class="m-newDetail">
			<div class="detail_cont">
				<div>
					<img class="list_img" :src="zidiyiData.news_center.files" />
				</div>
				<div class="cont_info">
					<el-row :gutter="30">
						<el-col :span="19">
							 <video :src="content.video" height="500" width="900" controls="controls" :poster="content.image"></video>
							<div class="info_left">
								<div class="left_tit">{{lang=='CN' ?content.cn_title:content.en_title}}</div>
								<div class="left_time_look">
									<span class="commo_span">{{content.publishtime_text}}</span>
									<span class="commo_span">
										<img src="@/assets/news/eye.svg" />
										<span>{{content.view}}</span>
									</span>
									<span class="commo_span">
										<img src="@/assets/news/comment.svg" />
										<span>{{content.comment_num}}</span>
									</span>
								</div>

								<div class="info_detail" v-html="lang=='CN' ?content.cn_content:content.en_content">
								</div>



								<div class="share">
									<span> {{lang=='CN' ?'分享到':'Share To'}}:</span>
									<img class="pointer" @click="shareToRoom()" src="@/assets/news/zone.png" />
									<img class="pointer" @click="shareToQQ()" src="@/assets/news/qqicon.png" />
									<img class="pointer" @click="shareToMicroblog()" src="@/assets/news/weibo.png" />
									
								</div>
								<div class="" v-if="content.is_comment">
									<div class="shuru_input">
										<el-input type="textarea" :rows="2"
											:placeholder="lang=='CN' ?'说两句吧':'Say something...'" v-model="textarea">
										</el-input>
										<div class="reat_btn" @click="send">
											{{lang=='CN' ?'发布评论':'Comment'}}

										</div>
									</div>
									<div class="rate_info">
										<div class="rate_tit">
											<span>{{lang=='CN' ?'全部评论':'All Comment'}}</span>
											<el-divider direction="vertical"></el-divider>
											<span>{{comTotal}}条</span>
										</div>
										<div class="rate_neirong" v-for="(item,index) in comList">
											<div class="rate_time">
												<span>{{lang=='CN' ?'访问客户':'Trator'}}</span>
												<span>{{item.createtime | formatDate}}</span>
											</div>
											<div class="rate_cont">
												{{item.comment}}
											</div>
											<div class="rate_footer">
												<!-- <span>赞1212</span> -->
												<!-- <span>回复</span> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-col>


						<el-col :span="5">
							<div class="info_right">
								<div class="right_tit text-uppercase">{{lang=='CN' ?'热点聚焦':'hot topic'}}</div>
								<div class="right_info">
									<div class="wrap" v-for="(item,index) in arcList" v-if="index<3">
										<div class="youDetail" v-if="index==0">
											<img :src="item.image" />
											<span>{{item.author}}</span>
										</div>
										<div class="youDetailList" @click.stop="detail(item.id)">
											<span class="tit_span">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
											<div class="goDetailBtn">
												<span>{{item.publishtime_text}}</span>
												<span
													class="btn_square css3"><em>{{lang=='CN' ?'了解详情':'Find out details'}}</em></span>
											</div>
										</div>
									</div>
									<div class="more_btn btn_square" @click.stop="go_hotList">
										<em data-v-957c9522="">查看更多 MOER</em><span data-v-957c9522=""></span>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>



		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import moment from 'moment'

	import Header from '@/components/Header'
	import Footer from '@/components/Footer'

	export default {
		components: {
			Header,
			Footer
		},
		name: 'new_detail',
		data() {
			return {
				textarea: '',
				id: '',
				content: {},
				arcList: [],
				total: '',
				company_id: 1, //公司ID
				commentList: [],
				per_page: 9,
				page: 1,
				zidiyiData: {
					news_center:{files:''}
				},
				comTotal: '',
				comList: [],
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		filters: {
			formatDate: function(value) {
				return moment(value * 1000).format('YYYY-MM-DD')
			}
		},
		
		created() {
		this.id = this.$route.query.id
		this.company_id = this.$route.query.id
		this.detail(this.id)
		this.getZidiyiData();
		this.getCommentList()
		let data = {
			channel_id: '',
			per_page: this.per_page,
			page: this.page,
			flag: 'hot'
		}
		
		this.$axios.get("/api/jx/archives_list", {
			params: data
		}).then((res) => {
		
			if (res.data.code == 1) {
				this.arcList = res.data.data.data
				this.total = res.data.data.total
			}
		}).catch(err => {});
		this.addLocatPath()	
		},
		mounted() {
			this.id = this.$route.query.id
			this.company_id = this.$route.query.id
			this.detail(this.id)
			this.getZidiyiData();
			this.getCommentList()
			let data = {
				channel_id: '',
				per_page: this.per_page,
				page: this.page,
				flag: 'hot'
			}
			
			this.$axios.get("/api/jx/archives_list", {
				params: data
			}).then((res) => {
			
				if (res.data.code == 1) {
					this.arcList = res.data.data.data
					this.total = res.data.data.total
				}
			}).catch(err => {});
			this.addLocatPath()
		},
		methods: {
			
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			detail(id) {
				let data = {
					id: id
				}
				
				this.$axios.get("/api/jx/archives_detail", {
					params: data
				}).then((res) => {
					
					console.log(res.data)
					if (res.data.code == 1) {
						this.content = res.data.data
						
					}
				}).catch(err => {});
			},
			send() {
				this.push()
			},
			addLocatPath() {
				let data = {
					directions: '新闻详情',
					path: window.location.href
				}
				
				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {
						
				}).catch(err => {});
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				
				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {

					this.zidiyiData = res.data.data
				}).catch(err => {});
			},
			push() {

				if(this.textarea.replace(/\s+/g,'')==''){
					 this.$message.error('请输入内容');
					 return
				}
				
				let data = {
					archives_id: this.id,
					comment: this.textarea
				}
				this.$axios.get("/api/jx/add_comment", {
					params: data
				}).then((res) => {
			
					if (res.data.code == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.textarea=''
						this.getCommentList()
					} else {
						this.$message.error(res.data.msg);
					}
				}).catch(err => {});
			},
			getCommentList() {
				let data = {
					archives_id: this.company_id,
					per_page: this.per_page,
					page: this.page
				}
				this.$axios.get("/api/jx/comment_list", {
					params: data
				}).then((res) => {
							
	
					this.comTotal = res.data.data.total
					this.comList = res.data.data.data
				}).catch(err => {});
			},
			go_hotList() {
				this.$router.push({
					path: `hot`
				})
			},
			//分享到QQ好友(PC端可用)
			shareToQQ() {
				//此处分享链接内无法携带图片
				const share = {
					title: this.content.cn_title,
					desc: this.content.cn_digest,
					share_url: window.location.href,
				};
				window.open(
					"https://connect.qq.com/widget/shareqq/index.html?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" +
					share.title +
					"&desc=" +
					share.desc
				);
			},
			//分享到QQ空间(可用)
			shareToRoom() {
				//自定义内容
				const share = {
					title: this.content.cn_title,
					desc: this.content.cn_digest,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				let image_urls = share.image_url.map(function(image) {
					return encodeURIComponent(image);
				});
				//跳转地址
				window.open(
					"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" + share.title +
					"&pics=" + image_urls.join("|") +
					"&summary=" + share.desc
				);
			},
			//分享到微博(可用)
			shareToMicroblog() {
				//自定义内容
				const share = {
					title: this.content.cn_title,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				//跳转地址
				// location.replace(
				window.open(
					"https://service.weibo.com/share/share.php?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" + share.title +
					"&pic=" + share.image_url +
					"&searchPic=true"
				);
			},
			//分享到微信(不可用)
			shareToWeChat() {
				//自定义内容
				// return
				const share = {
					title: this.content.cn_title,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				//跳转地址
				window.open(
					"http://zixuephp.net/inc/qrcode_img.php?url=" +
					encodeURIComponent(share.share_url)
				);
			}
		}
	}
</script>

<style   scoped>
	textarea {
		min-height: 100px !important;
	}

	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.m-newDetail {
		background: #fff;
	}

	.m-newDetail .detail_cont {
		padding: 30px;
	}

	.m-newDetail .detail_cont .detail_img {
		width: 100%;
	}

	.m-newDetail .cont_info {
		margin: 50px auto;
		width: 1200px;
	}

	.m-newDetail .left_tit {
		font-size: 28px;
		font-weight: bold;
	}

	.m-newDetail .left_time_look {
		margin-top: 30px;
	}

	.m-newDetail .left_time_look img {
		width: 20px;
	}

	.m-newDetail .commo_span {
		margin-right: 50px;
	}

	.m-newDetail .info_detail {
		margin-top: 50px;
	}

	.info_detail>>>img {
		width: 100%;
	}

	.m-newDetail .share {
		margin-top: 60px;
	}

	.m-newDetail .share img {
		width: 30px;
		height: 30px;
		margin-right: 20px;
	}
	.m-newDetail .share img:hover {
		background: none;
	}

	.m-newDetail .share span {
		margin-right: 20px;
	}

	.m-newDetail .shuru_input {
		display: flex;
		margin-top: 60px;
	}

	.el-textarea {
		display: inherit;
	}

	.el-textarea__inner {
		min-height: 100px !important;
	}

	.m-newDetail .shuru_input .reat_btn {
		width: 150px;
		height: 100px;
		background: #f5f5f5;
		text-align: center;
		line-height: 100px;
		font-size: 14px;
		font-weight: bold;
		cursor: pointer;
	}

	.m-newDetail .rate_tit {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #000;
		padding: 10px 0px;
		border-bottom: 1px solid #dddee4;
	}

	.m-newDetail .rate_info {
		margin-top: 60px;
	}

	.m-newDetail .rate_neirong {
		padding: 30px 0;
		font-size: 12px;
		color: #666;
		/* border-top: 1px solid #dddee4; */
		border-bottom: 1px solid #dddee4;
		margin-top: 10px;
	}

	.m-newDetail .rate_time,
	.rate_cont {
		margin-bottom: 10px;
	}

	.m-newDetail .rate_time {
		display: flex;
		align-items: center;
	}

	.m-newDetail .rate_time span:first-child {
		font-size: 16px;
		font-weight: bold;
		color: #000;
		margin-right: 20px;
	}

	.m-newDetail .rate_footer {
		color: #000;
	}

	.m-newDetail .rate_footer span {
		cursor: pointer;
	}

	.m-newDetail .rate_footer span:first-child {
		margin-right: 30px;
	}

	.m-newDetail .right_tit {
		background: #006170;
		width: 100%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		color: #fff;
		margin-bottom: 10px;
	}

	.m-newDetail .right_info {
		overflow: hidden;
	}

	.m-newDetail .right_info .wrap {
		overflow: hidden;
	}

	.m-newDetail .youDetail {
		display: flex;
		flex-direction: column;
		padding: 0 0 20px;
		border-bottom: 1px solid #eee;
		cursor: pointer;
	}

	.m-newDetail .youDetail img {
		width: 100%;
		height: 150px;
	}

	.m-newDetail .youDetail span {
		margin-top: 20px;
		margin-left: 10px;
	}

	.m-newDetail .youDetail:last-child {
		border-bottom: none;
	}

	.m-newDetail .youDetailList {
		cursor: pointer;
		padding: 40px 10px 40px 10px;
		border-bottom: 1px solid #eee;

	}

	.m-newDetail .youDetailList:hover {
		background: #ebf3f5;
	}

	.m-newDetail .tit_span {
		display: block;
		margin-bottom: 10px;
		font-size: 14px;
		height: 60px;
		line-height: 30px;
		color: #333;
	}

	.m-newDetail .goDetailBtn {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
		font-size: 14px;
		color: #999;
	}

	.m-newDetail .goDetailBtn span:last-child {
		width: 100px;
		height: 25px;
		line-height: 25px;
		text-align: center;
		color: #fff;
		background: #006170;
		cursor: pointer;
	}

	.m-newDetail .more_btn {
		font-size: 14px;
		color: #666;
		height: 50px;
		line-height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ebf3f5;
		font-weight: bold;
		cursor: pointer;
	}

	.m-newDetail .more_btn span {
		position: relative;
		top: -1px;
		background: url(~@/assets/img/arrows_gray.png) center no-repeat;
	}

	.m-newDetail .more_btn:hover {
		color: #ffffff;

	}


	.m-newDetail .more_btn:hover span {
		color: #ffffff;
		background: url(~@/assets/img/arrows_white.png) center no-repeat;
	}



	.m-newDetail .more_btn img {
		width: 20px;
		height: 20px;
	}

	.m-newDetail .more_btn span:nth-child(2) {
		padding: 0 10px;
	}

	.m-newDetail .el-divider {
		background-color: #000 !important;
	}

	.info_right {
		width: 230px;
	}
</style>

<style>
	textarea {
		border-radius: 0px !important;
	}
</style>
